// extracted by mini-css-extract-plugin
module.exports = {"imagemCabecalho":"ConteudoEmail_imagemCabecalho__20cu0","imagem":"ConteudoEmail_imagem__XHoVE","conteudoEmail":"ConteudoEmail_conteudoEmail__3t63S"};